<template>
  <div class="big">
    <el-dialog
      title="添加/编辑物品奖励"
      :visible.sync="dialogdata"
      width="620px"
      style="text-align: left"
      :close-on-click-modal="false"
      @open="opendialog"
    >
      <div class="uploadbox">
        <div>
          <el-button
            @click="addGood"
            type="primary"
            size="medium"
          >添加物品</el-button>
        </div>
        <div style="border: solid 1px #c9cbd6;margin-top:16px">
          <el-table :data="goodsList">
            <el-table-column
              label="物品图片"
              width="150"
            >
              <template slot-scope="scope">
                <div class="imagebox">
                  <el-upload
                    name="image"
                    accept=".png,.jpeg,.jpg"
                    :show-file-list="false"
                    :http-request=" (params) => {
                          uploadImg(params, scope.$index);
                        }"
                    action="goods_img"
                  >
                    <div slot="trigger">
                      <div v-if="scope.row.image_str">
                        <img
                          :src="scope.row.image_str"
                          alt=""
                          style="width:100px;width:100px"
                        >
                      </div>
                      <div
                        class="uploadbtn"
                        v-else
                      >
                        <i
                          class="el-icon-plus"
                          style="font-size:30px;margin-bottom:20px"
                        ></i>
                        <div>添加图片</div>
                      </div>
                    </div>
                  </el-upload>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="物品描述">
              <template slot-scope="scope">
                <div>
                  <el-input
                    v-model="scope.row.goods_name"
                    maxlength="10"
                    placeholder="不超过10个字"
                    style="width:240px"
                  ></el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="60"
            >
              <template slot-scope="scope">
                <div>
                  <el-button
                    type="text"
                    @click="delGoods(scope.$index)"
                  >删除</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div style="text-align: right; padding: 0 20px 20px 0; box-sizing: border-box">
        <el-button
          type="primary"
          @click="submit"
          style="width: 92px"
          size="medium"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { uploadImg } from '../../../service/common/constant';

export default {
  data() {
    return {
      dialogdata: false,
      uploadExtraData: {
        img_type: 6,
        suffix: '.jpg'
      },
      goodsList: [
        {
          image: '',
          goods_name: ''
        }
      ]
    };
  },
  watch: {
    isFlag() {
      this.dialogdata = true;
    }
  },
  computed: {
    uploadUrl() {
      if (process.env.NODE_ENV == 'development') {
        // 本地开发使用 api 前缀
        return '/api/platform/upload/uploadFile';
      } else {
        return '/platform/upload/uploadFile';
      }
    },
    uploadHeaders: function () {
      return Object.assign(
        {},
        _.pick(constant.HEADERS, ['version', 'platform']),
        {
          timestamp: Date.now(),
          token: this.$store.state.login.headerToken
        }
      );
    }
  },
  props: ['isFlag', 'list'],
  methods: {
    //提交
    submit() {
      if (!this.goodsList.length) {
        this.$message.error('请填写奖励物品信息');
        return false;
      }
      for (let i = 0; i < this.goodsList.length; i++) {
        if (!this.goodsList[i].image || !this.goodsList[i].goods_name) {
          this.$message.error('请完善奖励物品信息');
          return false;
        }
      }
      this.$emit('refreshData', this.goodsList);
      this.dialogdata = false;
    },
    addGood() {
      if (this.goodsList.length == 6) {
        this.$message.error('最多添加6个物品');
        return false;
      }
      let data = {
        image: '',
        goods_name: ''
      };
      this.goodsList.push(data);
    },
    //删除
    delGoods(index) {
      this.goodsList.splice(index, 1);
    },
    //上传图片
    uploadImg(params, index) {
      let file = params.file;
      uploadImg(file)
        .then((res) => {
          this.$set(this.goodsList[index], 'image', res.data.pic);
          this.$set(this.goodsList[index], 'image_str', res.data.path);
          this.$forceUpdate();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    opendialog() {
      if (this.list.length) {
        this.goodsList = this.list;
      } else {
        this.goodsList = [
          {
            image: '',
            goods_name: ''
          }
        ];
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.uploadbox {
  padding: 30px 40px;
  box-sizing: border-box;
}
.filebox {
  line-height: 32px;
}
.imagebox {
  width: 100px;
  height: 100px;
  border: 1px solid #dedede;
}
.uploadbtn {
  color: #999;
  width: 100px;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 12px;
}
</style>
